import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/gd.png";
import GDFAQ from "./GDFAQ";
import GDCurriculum from "./GDCurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import GDPricing from "./GDPricing";
import { Link } from "react-router-dom";
export default function GDPage() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "Graphic Design",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxpGr46MBF4HmNpxOYLbt2mQRcjEVPS5PtI1iZdXAMgIxORthvV4iD0Ev1zPEAsXZoK/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "Graphic Design",
        });
      } else {
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "Graphic Design",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">Graphic Design</h1>
          <p className="program-detail-desc">
            Graphic design is visual storytelling. It blends shape, color, and
            emotion to communicate ideas without a single spoken word. From
            logos and posters to digital interfaces, design makes brands
            memorable, experiences meaningful, and imagination visible.
          </p>
          <div className="program-detail-actions">
            <Link to="/register">
              <button className="register-btn">Register Now</button>
            </Link>
            <Link to="/contact-us">
              <button className="expert-btn">Talk To Expert</button>
            </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
            Graphic design is not about making things “look pretty”—it’s about
            crafting messages people feel. At Acadme, you begin with visual
            psychology, composition, typography, and color theory. You explore
            how contrast creates attention, how spacing breathes clarity, and
            how identity flows through every design. You’ll master tools like
            Photoshop, Illustrator, Figma, and motion essentials, transforming
            sketches into professional assets. The internship places you inside
            real creative workflows—designing brand kits, social media layouts,
            UI screens, and campaign visuals. You learn how to accept feedback,
            polish ideas, and deliver work that moves audiences. If you want to
            turn creativity into a profession, enroll and let your designs speak
            for you.
          </p>
        </motion.div>
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>

          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <GDCurriculum />
      <SkillPage />
      <Certificate />
      <GDPricing />
      <GDFAQ />
    </>
  );
}
